/* eslint-disable no-underscore-dangle */
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import withViewport from "../Viewport/withViewport";
import classnames from "classnames";
import styles from "./index.css";

const cx = classnames.bind(styles);

const globalBannerId = "divGlobalBanner";

class GlobalBanner extends PureComponent {
  hasInitialised = false;
  hasTimedOut = false;

  static propTypes = {
    storeCode: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
    identityHasResponded: PropTypes.bool.isRequired,
    isPremier: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool,
    browseCountry: PropTypes.string.isRequired
  };

  componentDidMount() {
    this.check();

    setTimeout(() => {
      this.timedOut = true;
      this.check();
    }, 500);
  }

  componentDidUpdate() {
    this.check();
  }

  check() {
    const {
      identityHasResponded,
      isVisible,
      storeCode,
      language,
      isPremier,
      browseCountry
    } = this.props;

    const needsInitialisation = !this.hasInitialised && isVisible;

    if ((identityHasResponded || this.timedOut) && needsInitialisation) {
      window.__globalBannerSDK.init(
        storeCode,
        language,
        isPremier,
        globalBannerId,
        browseCountry
      );

      this.hasInitialised = true;
    }
  }

  render() {
    const { isVisible } = this.props;
    return (
      <div
        id={globalBannerId}
        className={cx(styles.globalBanner, {
          [styles.visible]: isVisible
        })}
      />
    );
  }
}

export default withViewport(GlobalBanner);



// WEBPACK FOOTER //
// ./template/components/GlobalBanner/GlobalBanner.js